
import ForwardItem from "../../../assets/outline/ForwardItem.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ForwardItemIcon({ className, dataTestid = "ForwardItemIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ForwardItem data-testid={dataTestid} className={classes} {...rest} />
  );
}
